export default "__VITE_ASSET__Y_js5F3L__"